export default "__VITE_ASSET__DAlXLlsa__"